import React from "react";
import MenuItem from "@mui/material/MenuItem";

const BuildingBlocksMenuListItem2Density = (props) => <MenuItem dense {...props} />;

export default BuildingBlocksMenuListItem2Density;
